import React, { useContext } from 'react';
import { useLocation, useNavigate, useOutletContext, useParams } from 'react-router-dom';

import { SimpleAppBar } from '_lib/components/AppBar/SimpleAppBar';
import { FlexBox } from '_lib/components/FlexBox/FlexBox';

import { AppRouteContext } from '../App/app.types';

import { AuthContext } from '../auth/authContext';
import { appRoutePaths, getFullAppRoutePath, hasGoBack } from '../Nav/nav.types';

import { UserCreate } from './UserCreate';
import { UserUpdate } from './UserUpdate';

export const UserDetailRoute = () => {
  const { appDrawerState } = useOutletContext<AppRouteContext>();

  const { id } = useParams() as { id: string };
  const navigate = useNavigate();
  const location = useLocation();

  const { authUserCacheResource, callCenterCacheResource } = useContext(AuthContext);

  const cachedAuthUserQuery = authUserCacheResource.useCacheQuery();
  const cachedCallCenterQuery = callCenterCacheResource.useCacheQuery();

  const isFetching = cachedAuthUserQuery.isFetching || cachedCallCenterQuery.isFetching;

  return (
    <FlexBox sx={{ flexDirection: 'column', height: '100%', width: '100%' }}>
      <SimpleAppBar
        title={id === 'new' ? 'User Create' : 'User'}
        onBackClicked={() => {
          const locationState = location.state;
          if (hasGoBack(locationState)) {
            navigate(locationState.goBack.url);
          } else {
            navigate(getFullAppRoutePath(appRoutePaths.User));
          }
        }}
        onAppDrawerToggleClicked={appDrawerState?.openSlidingDrawer}
      />
      {id === 'new' ? (
        <UserCreate
          isFetchingFromProps={isFetching}
          callCenterId={cachedCallCenterQuery?.data?.id}
          authUser={cachedAuthUserQuery?.data}
          onSave={(user) => {
            navigate(`${getFullAppRoutePath(appRoutePaths.User)}/${user.id}`, { replace: true });
          }}
        />
      ) : (
        <UserUpdate userId={id} authUser={cachedAuthUserQuery?.data} isFetchingFromProps={isFetching} />
      )}
    </FlexBox>
  );
};
